import { Building2, Cloud, Mail, PenLine } from 'lucide-react';
import { useIntl } from 'react-intl';

const PROVIDER_ICONS: Record<string, typeof Building2> = {
  brreg: Building2,
  manual: PenLine,
  google: Mail,
  icloud: Cloud,
};

/** Provider icon + short label; opens the provenance drawer (Design Principles #1). */
export function SourceChip({ provider, onOpen }: { provider: string; onOpen: () => void }) {
  const intl = useIntl();
  const Icon = PROVIDER_ICONS[provider] ?? Building2;
  const message = (id: string) => (intl.messages[id] ? intl.formatMessage({ id }) : provider);
  const providerLabel = message(`provenance.provider.${provider}`);
  const shortLabel = message(`provenance.provider.${provider}.short`);
  return (
    <button
      type="button"
      onClick={onOpen}
      className="inline-flex items-center gap-1 rounded px-1 py-px text-xs text-muted hover:bg-hover hover:text-text focus-visible:outline-2 focus-visible:outline-accent"
      aria-label={intl.formatMessage({ id: 'provenance.open' })}
      title={providerLabel}
    >
      <Icon aria-hidden className="size-3" />
      <span className="max-w-24 truncate">{shortLabel}</span>
    </button>
  );
}
